import { Link, Outlet, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/admin', label: 'Overview', exact: true },
  { path: '/admin/users', label: 'Users' },
  { path: '/admin/teams', label: 'Teams' },
  { path: '/admin/costs', label: 'Costs' },
  { path: '/admin/queues', label: 'Queues' },
  { path: '/admin/audit', label: 'Audit Log' },
];

export function AdminLayout() {
  const location = useLocation();

  function isActive(path: string, exact?: boolean) {
    return exact ? location.pathname === path : location.pathname.startsWith(path);
  }

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="flex items-center gap-3 mb-8">
        <h1 className="text-3xl font-bold text-ll-text">Admin</h1>
        <span className="text-xs font-bold uppercase px-2 py-0.5 rounded bg-ll-amber/20 text-ll-amber">
          Admin
        </span>
      </div>

      <div className="flex gap-8">
        {/* Sidebar */}
        <nav className="w-48 shrink-0 hidden md:block">
          <ul className="space-y-1">
            {NAV_ITEMS.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`block px-3 py-2 rounded-lg text-sm transition-colors ${
                    isActive(item.path, item.exact)
                      ? 'bg-ll-cyan/10 text-ll-cyan font-medium'
                      : 'text-ll-muted hover:text-ll-text hover:bg-white/5'
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Mobile nav */}
        <div className="md:hidden w-full mb-6">
          <div className="flex gap-1 overflow-x-auto border-b border-ll-border pb-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 text-sm whitespace-nowrap rounded-t transition-colors ${
                  isActive(item.path, item.exact)
                    ? 'text-ll-cyan border-b-2 border-ll-cyan'
                    : 'text-ll-muted hover:text-ll-text'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
